import { makeAutoObservable } from 'mobx'
import { Exercise, Program } from '@entities/program'

interface TrainingMetaInfo {
	image: string
	name: string
	id: number
}

class TrainingStore {
	public startTime: Date | null = new Date()
	public completedExercises: number = 0
	public endTime: Date | null = null
	private training_: { program: TrainingMetaInfo; exercises: Exercise[]; dayID: number } = {
		exercises: [],
		program: {
			id: 0,
			name: '',
			image: '',
		},
		dayID: 0,
	}
	public exercisesAmount: number = this.training_.exercises.length
	private exerciseIndex_: number = 0

	constructor() {
		makeAutoObservable(this)
	}

	public get exercise() {
		if (this.exercisesAmount > this.exerciseIndex_) {
			return this.training_.exercises[this.exerciseIndex_]
		}
		return false
	}

	public get dayID() {
		return this.training_.dayID
	}

	public get programInfo() {
		return this.training_.program
	}

	public get index() {
		return this.exerciseIndex_
	}

	public setTraining = (training: { program: Program; exercises: Exercise[]; dayID: number }) => {
		this.training_ = training
		this.exerciseIndex_ = 0
		this.exercisesAmount = this.training_.exercises.length
		this.completedExercises = 0
		this.startTime = new Date()
	}

	public incrementExerciseIndex = async () => {
		this.exerciseIndex_++
	}

	public incrementCompletedExercises = () => {
		this.completedExercises++
		console.log('store index', this.completedExercises)
	}

	public endTraining = () => {
		this.endTime = new Date()
	}

	public decrementExerciseIndex = async () => {
		this.exerciseIndex_ = Math.max(this.exerciseIndex_ - 1, -1)
	}
}

export const trainingStore: TrainingStore = new TrainingStore()
